import Head from 'next/head';
import Image from 'next/image';
import Layout from '../../../ui/layout';
import { Wrap, Button, ButtonInverted } from '../../../styled';
import { TypeformButtonMain } from '../../../components';
import {
  H3,
  DemoInner,
  Testimonials,
  TestimonialsQuote,
  TestimonialsOrigin,
  Description,
  DescriptionImage,
  DescriptionText,
} from '../styled/child';
import {
  Intro,
  Heading,
  IntroTextContainer,
  IntroImageContainer,
  FactsWrapper,
  FactsList,
  FactsListItem,
  StoryInner,
  StoryText,
  VisitWrapper,
  VisitHeading,
  VisitDescription,
} from './styled';

import intro from './images/intro.jpg';
import logo from './images/logo.svg';
import vp from './images/vp.png';
import widget1 from './images/widget-1.jpg';
import widget2 from './images/widget-2.jpg';

const SuccessStoriesHead = () => (
  <Layout>
    <Head>
      <meta name="image" property="og:image" content={intro.src} />
    </Head>
    <Intro>
      <Wrap>
        <IntroTextContainer>
          <Heading>HEAD finds the Perfect Fit, Partnering with EyeFitU</Heading>
        </IntroTextContainer>
      </Wrap>
      <IntroImageContainer>
        <Image
          src={intro}
          alt="People wearing HEAD clothes"
          style={{ objectFit: 'cover', height: '100%' }}
          priority
        />
      </IntroImageContainer>
    </Intro>
    <FactsWrapper>
      <Wrap>
        <FactsList>
          <FactsListItem>
            “Our return rate decreased by over 35%”.
          </FactsListItem>
          <FactsListItem>
            “More than 25% of EyeFitU users are buying”.
          </FactsListItem>
          <FactsListItem>
            “EyeFitU is a reliable and trusted data ally that will positively
            impact HEAD’s financial performance”.
          </FactsListItem>
        </FactsList>
      </Wrap>
    </FactsWrapper>
    <Wrap>
      <Description>
        <DescriptionImage>
          <Image src={logo} width="392" height="104" alt="HEAD logo" />
        </DescriptionImage>
        <DescriptionText>
          <p>
            HEAD, an Austrian based global manufacturer and retailer of sports
            equipment and clothing, has been live with the EyeFitU SizeEngine™
            since February 2022.
          </p>
          <p>
            With size and fit presenting a significant challenge to buying
            clothing and footwear online, integrating the EyeFitU SizeEngine™
            into the HEAD e-commerce platform answers the eternal question “will
            it fit me?”.
          </p>
          <p>
            Powered by advanced AI, data analytics, and Machine Learning,
            together with one of the industry’s largest and most diverse data
            set, the EyeFitU SizeEngine™ enhances the shopping experience by
            taking the guesswork out of shopping online, and providing customers
            with the confidence to choose the right size and fit every time.
          </p>
        </DescriptionText>
      </Description>
    </Wrap>
    <Testimonials>
      <Wrap>
        <Image
          src={vp}
          width="192"
          height="192"
          alt="Roman Stepek, Vice President, Head Sportswear"
        />
        <TestimonialsQuote>
          “We’ve seen more than 25% of the widget users are buying and
          simultaneously our return rate decreased by over 35%.”
        </TestimonialsQuote>
        <TestimonialsOrigin>
          — Roman Stepek, Vice President, HEAD Sportswear
        </TestimonialsOrigin>
      </Wrap>
    </Testimonials>
    <Wrap>
      <StoryInner>
        <StoryText>
          Ease of integration is of paramount importance with no place for the
          traditional challenges posed by third-party integrations, especially
          given the volume of transactions faced by a global company like HEAD,
          as Roman Stepek observes:
          <q>
            In addition, we didn’t have to use any of our own IT resources to
            implement the widget. The team at EyeFitU did all the integration
            for us providing us with tips and ideas for us to get the most out
            of their sizing solution for our customers.
          </q>
        </StoryText>
        <StoryText>
          HEAD is also leveraging EyeFitU’s data including anthropometric and
          behavioural analytics to improve fit consistency, which develops
          customer insights while feeding data back into the value chain
          optimising supply, production, inventory, and merchandising functions.
        </StoryText>
        <StoryText>
          Expanding upon the collaboration with HEAD, Isabelle Ohnemus Founder
          and CEO of EyefitU expresses the importance of brands finding a size
          and fit data partner:
          <q>
            In the upcoming years, as competition intensifies across all levels
            of the industry, maintaining margins and extracting unnecessary
            costs attributable to inefficiencies in the supply chain, along with
            minimising returns, will become an imperative. In partnering with
            EyeFitU, HEAD has a reliable and trusted data ally that will
            positively impact HEAD’s financial performance well into the future.
          </q>
        </StoryText>
        <StoryText>
          By adding the all-important size and fit to the customer data set
          EyeFitU will be instrumental in assisting HEAD to enhance its
          competitive response to what is fast becoming the new normal -
          hyper-personalization of the shopping experience.
        </StoryText>
        <br />
        <Image src={widget2} alt="" width={856} height={416} />
        <br />
        <Image src={widget1} alt="" width={856} height={448} />
      </StoryInner>
    </Wrap>
    <VisitWrapper>
      <Wrap>
        <VisitHeading>
          Visit HEAD and test-drive EyeFitU SizeEngine™.
        </VisitHeading>
        <ButtonInverted
          href="https://www.head.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit HEAD
        </ButtonInverted>
        <VisitDescription>
          Do you have a size and fit challenge of your own? Contact us today,
          and discover how EyeFitU SizeEngine™ can help your brand boost
          conversions, and basket size, while minimising returns.
        </VisitDescription>
      </Wrap>
    </VisitWrapper>
    <Wrap>
      <DemoInner>
        <div>
          <H3>Book a Meeting</H3>
          <Button as={TypeformButtonMain}>Let’s talk</Button>
        </div>
      </DemoInner>
    </Wrap>
  </Layout>
);

export default SuccessStoriesHead;
